import { render, staticRenderFns } from "./EditBasic.vue?vue&type=template&id=ea25a710&lang=pug"
import script from "./EditBasic.vue?vue&type=script&lang=js"
export * from "./EditBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports